/**
 * @oz/rules — motor de regras do OZ Emblem.
 *
 * TypeScript puro, sem DOM, sem rede e sem acesso a disco: o mesmo pacote roda
 * no navegador (previsão e desenho) e no servidor Node (autoridade). É essa
 * fonte única que impede cliente e servidor discordarem sobre o resultado de
 * uma ação.
 */
export { Rng } from './rng.js';
export * from './types.js';
export * from './content.js';
export * from './stats.js';
export * from './grid.js';
export * from './movement.js';
export * from './combat.js';
export * from './progression.js';
export * from './states.js';
export * from './state.js';
export * from './actions.js';
export * from './match.js';
export * from './policy.js';
export * from './ai/index.js';
/** Versão do formato de estado de partida. Sobe quando o formato quebra. */
export const STATE_FORMAT_VERSION = 1;
//# sourceMappingURL=index.js.map